/**
 * Sticky component
 * ----------------
 */

/* Imports */

import React, { useState, useRef, useLayoutEffect } from "react";
import Marquee from "../Marquee";
import Graphic from "../Graphic";
import {
  Sticky,
  StickyMain,
  StickyLeft,
  StickyRight,
  StickyMedia,
  StickyP,
} from "./styles.module.scss";

/* Component */

const StickyComponent = () => {
  const [top, setTop] = useState("50vh");
  const showEl = useRef(null);

  let resizeTimer;

  const getTop = () => {
    return `calc(50vh - ${showEl.current.clientHeight / 2}px)`;
  };

  const resize = () => {
    // throttles resize event
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      setTop(getTop());
    }, 100);
  };

  useLayoutEffect(() => {
    setTop(getTop());

    window.addEventListener("resize", resize);

    return () => {
      // clean up
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <div className={`${Sticky} lc-sticky lc-container`}>
      <div
        className={`${StickyP} lc-sticky__p lc-pad-v-t`}
        data-size="xl"
        data-mobile
      />
      <div
        className={`${StickyMain} lc-sticky__main lc-flex lc-p-r`}
        data-gap="l"
        data-mobile
      >
        <div
          className={`${StickyLeft} lc-sticky__left lc-p-r lc-z-1`}
          data-anchor
        >
          <Marquee ariaHidden="true" sticky="top" />
          <div className="lc-100">
            <div className={`${StickyMedia} lc-sticky__media lc-p-r`}>
              <Graphic
                classes="lc-sticky__anim"
                item="#s1"
                threshold={0.5}
                toggle
              />
              <Graphic
                type={2}
                classes="lc-sticky__anim"
                item="#s2"
                threshold={0.5}
                toggle
              />
            </div>
          </div>
          <Marquee ariaHidden="true" sticky="bottom" />
        </div>
        <div
          className={`${StickyRight} lc-sticky__right lc-flex-grow`}
          data-scroll
        >
          <div id="s1" className="lc-pad-v" data-size="l" data-mobile>
            <div
              className="lc-flex"
              data-align="center"
              data-gap="l"
              data-wrap
              data-mobile
            >
              <div
                className={`${StickyLeft} lc-sticky__left lc-ta-c`}
                data-hide
              >
                <div className="lc-sticky__anim">
                  <Graphic />
                </div>
              </div>
              <div
                ref={showEl}
                className={`${StickyRight} lc-sticky__right lc-flex-grow`}
                data-show
                style={{ top }}
              >
                <h2 className="lc-v-h">Strategies for every single platform</h2>
                <p
                  className="lc-tx-l lc-move-fade-y lc-vis"
                  data-spd="s"
                  data-delay="200"
                >
                  To help, we're sharing how to create content that's unique to
                  your brand &mdash; no matter what (or where) you're sharing.
                </p>
              </div>
            </div>
          </div>
          <div id="s2">
            <div
              className="lc-flex lc-flex-grow"
              data-align="center"
              data-gap="l"
              data-wrap
              data-mobile
            >
              <div
                className={`${StickyLeft} lc-sticky__left lc-ta-c`}
                data-hide
              >
                <div className="lc-sticky__anim">
                  <Graphic type={2} />
                </div>
              </div>
              <div className={`${StickyRight} lc-sticky__right lc-flex-grow`}>
                <h2 className="lc-v-h">
                  Advice you can use – without the fluff
                </h2>
                <p
                  className="lc-tx-l lc-move-fade-y lc-vis"
                  data-spd="s"
                  data-delay="200"
                >
                  Get exclusive (and seriously helpful) tips to create a
                  successful strategy across ALL platforms. Yep, all of them
                  &mdash; it’s worth it, we promise.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`${StickyP} lc-sticky__p lc-pad-v-t`}
        data-size="xl"
        data-mobile
      />
    </div>
  );
};

/* Export */

export default StickyComponent;
